import React from 'react';
// import Carousel from 'react-material-ui-carousel'

import "./ImageCarousel.css"

const ImageCarousel = () => {
  return (
    // <Carousel
    //   indicators={false}
    //   timeout={200}
    //   navButtonsAlwaysInvisible
    // >
    //   <div className="Carousel__Image Carousel__Image--1"></div>
    //   <div className="Carousel__Image Carousel__Image--2"></div>
    // </Carousel>
    <div className="Carousel__Image Carousel__Image--1"></div>
  )
}

export default ImageCarousel;
